module.exports = __webpack_public_path__ + "img/bottom_6.49ea9ef8.png";